// Single source of truth for the panel's front-facing identity.
// Rename here and it propagates to auth, share copy and payout proof.
export const BRAND = {
  name: 'LikeUp',
  headlineKey: 'authHeadline',
  subKey: 'authSub'
};

// Payout rails shown as concrete proof on the auth screen.
export const PAYOUT_RAILS = [
  { id: 'paypal', label: 'PayPal' },
  { id: 'usdt', label: 'USDT' },
  { id: 'trx', label: 'TRC-20' },
  { id: 'gift', label: 'Gift card' }
];
